var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWifi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 222.08 143.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#231f20;stroke-width:0px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.45,45.86c-3.33,0-6.55-1.76-8.27-4.88-2.52-4.56-.86-10.3,3.7-12.82C38.7,9.47,74.42,0,111.04,0s72.34,9.47,106.16,28.15c4.56,2.52,6.22,8.26,3.7,12.82-2.52,4.56-8.26,6.22-12.83,3.7-31-17.12-63.64-25.8-97.04-25.8S45,27.56,14,44.68c-1.45.8-3.01,1.18-4.55,1.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.13,79.58c-3.56,0-6.97-2.03-8.57-5.47-2.19-4.73-.14-10.34,4.59-12.53,23.75-11.01,48.61-16.59,73.89-16.59s50.14,5.58,73.89,16.59c4.73,2.19,6.79,7.8,4.59,12.53-2.19,4.73-7.81,6.79-12.53,4.59-21.24-9.85-43.43-14.84-65.95-14.84s-44.71,4.99-65.95,14.84c-1.29.6-2.64.88-3.96.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M149.1,110.17c-.92,0-1.85-.13-2.77-.42-23.02-7.05-47.57-7.05-70.59,0-4.97,1.53-10.26-1.27-11.79-6.26-1.53-4.98,1.27-10.26,6.26-11.79,26.6-8.15,55.05-8.15,81.65,0,4.98,1.53,7.79,6.81,6.26,11.79-1.24,4.06-4.98,6.68-9.02,6.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M116.34,142.41l13.26-7.95c3.97-3.12,1.76-9.5-3.29-9.5h-30.53c-5.05,0-7.26,6.38-3.29,9.5l13.26,7.95c1.32.69,2.79,1.05,4.27,1.05h2.04c1.49,0,2.96-.36,4.27-1.05Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifi);
export default __webpack_public_path__ + "static/media/wifi.14baff5d4fab843a56c90b961f1e5990.svg";
export { ForwardRef as ReactComponent };